// extracted by mini-css-extract-plugin
module.exports = {"navLink":"PromoCodeModal_navLink__BTFxQ","modalCenterInMobile":"PromoCodeModal_modalCenterInMobile__B01hv","alertModal":"PromoCodeModal_alertModal__RC7tx"};